export default __webpack_public_path__ + "static/Mobile_SeriesPage_Headline-7bfed418836d74915ccd256f2ec9e07f.svg";